<div class="card">
    <div class="title">
        @if (pending()) {
        <mat-icon class="icon">error</mat-icon>
        }
        <span class="title-text">
            @if (pending()) {
            @if(petitions().personal){
            Tiene <strong>{{petitions().days}}</strong> días <strong>personales</strong> pendientes de aprobación
            } @else {
            Tiene <strong>{{petitions().days}}</strong> días pendientes de aprobación
            }
            }@else {
            @if(petitions().personal){
            @if (petitions().days > 1) {
            <strong>{{petitions().days}}</strong> días <strong>personales</strong>:
            } @else {
            <strong>{{petitions().days}}</strong> día <strong>personal</strong>:
            }

            } @else {
            <strong>{{petitions().days}}</strong> días de vacaciones:
            }
            }
        </span>
    </div>

    @if (petitions().weeks && petitions().weeks!.length > 0) {
    <div class="weeks-list">
        @for (week of petitions().weeks; track week.weekNumber) {
        <div class="week-item">
            <span class="week-dates">{{ week.startDate }} - {{ week.endDate }}</span>
            <span class="week-days">({{ week.dayCount }} días)</span>
        </div>
        }
    </div>
    } @else {
    <div class="dates">
        {{getFormattedDates()}}
    </div>
    }

    @if (pending()) {
    <div class="buttons">
        <!-- <button mat-flat-button id="action" (click)="validatorPetition()">Debug: validators</button> -->
        <button mat-flat-button id="action" (click)="approvePetition()">Aprobar petición</button>
        <button mat-flat-button id="delete" (click)="rejectPetition()">Rechazar</button>
    </div>
    }
</div>